module.exports = __webpack_public_path__ + "img/D-LOAN-BACKOFFICE.79803949.png";